// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__216Rz","disabled":"FileBtn_disabled__3zmkw","warn":"FileBtn_warn__15DWy","fade":"FileBtn_fade__3YQg_"};